import React from "react";
import chatStyle from "../../styles/ChatScreen.module.css";
import ChatSkeleton from "../../Skeletons/ChatSkeleton";
import ChatInputBox from "../../components/Modal/ChatInput";
import AddTemplateModal, {
  IAddTemplateModalState,
} from "../Chat/AddTemplateModal";
import Modal from "../../components/Modal/Modal";
import ModalHeading from "../../components/Modal/ModalHeading";
import { InputsSection } from "../../components/Modal/index";
import encrypt from "../../utils/encrypt";

import { loginSliceValue } from "../../redux/reducers/loginSlice";
import { useSelector } from "react-redux";
import { ISelectedTemplate } from "../Chat/AddTemplateModal";
import { useAllTemplate } from "../../hooks/rtmTemplate";

import { IPatient } from "../../hooks/patients/index.type";
import { groupMessagesByDate } from "../../utils/time";
import { useFetchChat, useSendChat } from "../../hooks/chats";
import ChatMessages from "../Chat/ChatMessage";

export interface IchatModalProps {
  status?: boolean;
  patientData?: IPatient;
  onClose: () => void;
}

const ChatModal: React.FC<IchatModalProps> = ({
  status,
  patientData,
  onClose,
}) => {

  // const associationId = patientData?.association?._id;
  const associationId = patientData?.associatedClinic._id;
  const { _id: patientId, name: patientName } = patientData || {};

  const pageNumber = 1;
  const perpageData = 20;
  let searchKey = "";
  const chatScreenRef = React.useRef<HTMLDivElement>(null);
  const { templateData, getTemplateData, templateDataLoading } = useAllTemplate(
    { page :pageNumber, searchKey ,status:"",type:"" }
  );
  const { chatData, getChatData, chatDataLoading } = useFetchChat({
    patientId,
  });
  const { sendChatLoading, sendChat } = useSendChat();
  const { userDetails } = useSelector(loginSliceValue);
  let id = userDetails.data?.user?._id;
  const [message, setMessage] = React.useState<string>("");
  const [isTemplateModal, setIsTemplateModal] =
    React.useState<IAddTemplateModalState>({
      status: false,
    });

  const [selectedTemplate, setSelectedTemplate] =
    React.useState<ISelectedTemplate | null>(null);
  const [selectedAttachments, setSelectedAttachments] = React.useState<
    string[]
  >([]);

  React.useEffect(() => {
    getTemplateData();
  }, [pageNumber, searchKey]);

  React.useEffect(() => {
    getChatData();
  }, []);

  React.useEffect(() => {
    if (chatScreenRef.current) {
      chatScreenRef.current.scrollTop = chatScreenRef.current.scrollHeight;
    }
  }, [chatData]);

  const handleTemplateSelect = (selectedTemplate: ISelectedTemplate) => {
    setSelectedTemplate(selectedTemplate);
    setMessage(selectedTemplate.message);
  };

  const sendMessage = async () => {
    if (message.trim() === "") return;
    const encryptedData = await encrypt(message);

    if (!encryptedData) {
      console.error("Message encryption failed!");
      return;
    }

    const payload = {
  clinicianPatientAssociation: patientId,
  receiver: patientId ?? "",
  iv: encryptedData.iv,
  encryptedAESKey: encryptedData.encryptedAESKey,
  encryptedMessage: encryptedData.encryptedMessage,
  authTag: encryptedData.authTag,
  messageType: "text",
  rtmPlan: "",
  rtmTemplate: selectedTemplate?.id,
  createdTimestamp: Date.now(),
};

    try {
      const data = await sendChat(payload);
      if (data?.status == "success") {
        setMessage("");
        getChatData();
      }
    } catch (error) {
      console.error("Error sending chat:", error);
    }
  };

  const handleRemoveAttachment = (index: number) => {
    setSelectedAttachments((prevAttachments) =>
      prevAttachments.filter((_, i) => i !== index)
    );
  };

  const groupedChatData = groupMessagesByDate([...chatData]);

  return (
    <Modal
      show={status}
      style={{ height: "80%", minWidth: "70%", paddingTop: "0" }}
    >
      <svg className={chatStyle.cancel_icon} onClick={onClose}>
        <use xlinkHref={`/assets/sprite.svg#icon-cancel`} />
      </svg>

      <ModalHeading heading={patientName} />
      <InputsSection style={{ maxHeight: "80%", width: "100%", padding: "0" }}>
        <div className={chatStyle.chatBox}>    
          <ChatMessages
          chatData={chatData}
          loading={chatDataLoading}
          chatScreenRef={chatScreenRef}
          patientId={patientId}
          />
          {/* Input Box & Icons */}
          <div className={chatStyle.inputContainer}>
            <ChatInputBox
              icon="icon-attach-file"
              icon2="icon-send-chat"
              placeholder="Type your text here"
              rows={2}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              style={{
                borderRadius: "1rem",
                flexGrow: 1,
              }}
              onClickIcon={() => setIsTemplateModal({ status: true })}
              onClickIcon2={sendMessage}
              icon_tooltip="Templates"
              icon2_tooltip="send"
            />
          </div>
          <div className={chatStyle.selectedItemsContainer}>
            {selectedAttachments.length > 0 && (
              <div className={chatStyle.selectedItemsContainer}>
                {selectedAttachments.map((attachment, index) => (
                  <div key={index} className={chatStyle.selectedAttachments}>
                    <span className={chatStyle.attachmentText}>
                      {attachment}
                    </span>
                    <button
                      className={chatStyle.deleteButton}
                      onClick={() => handleRemoveAttachment(index)}
                    >
                      ✖
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </InputsSection>

      {isTemplateModal.status && (
        <AddTemplateModal
          loading={templateDataLoading}
          addTemplateModal={isTemplateModal}
          onCloseModal={() => setIsTemplateModal({ status: false })}
          handleAddTemplate={handleTemplateSelect}
          templateData={templateData}
        />
      )}
    </Modal>
  );
};

export default ChatModal;
